"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQnaList = exports.useQnaDownload = exports.deleteQna = exports.modifyQna = exports.registQna = exports.getQnaList = void 0;
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
// (Qna) qna 리스트 조회
const getQnaList = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/qnas?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.getQnaList = getQnaList;
// (QnA) qna 등록
const registQna = async (data) => {
    const url = `/api/mimac/v1/qnas`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.registQna = registQna;
// (QnA) qna 수정
const modifyQna = async (data) => {
    const url = `/api/mimac/v1/qnas/${data.id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
    });
};
exports.modifyQna = modifyQna;
// (QnA) qna t삭제
const deleteQna = async (id) => {
    const url = `/api/mimac/v1/qnas/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.deleteQna = deleteQna;
const getQnaDownLoad = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/qnas?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
// (Qna) qna 리스트 다운로드
const useQnaDownload = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)(`qna_${queryString}`, () => getQnaDownLoad(queryString));
};
exports.useQnaDownload = useQnaDownload;
// (Qna) qna 리스트 조회 - useQnaLists
const useQnaList = (data, scope) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    const key = scope ? `qna_${scope}_${queryString}` : `qna_${queryString}`;
    return (0, functions_1.useCustomQuery)([key, scope], () => (0, exports.getQnaList)(queryString));
};
exports.useQnaList = useQnaList;
